import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import BatchLookupTable from "./-batch-lookup-table";
import WarehouseProductDetails from "./-product-details";
import ComponentsCard from "./-components-card";
import { getGetWarehouseQueryOptions } from "@/requests/gen/react-query/warehouse";
import { WarehouseCrumbs } from "../-crumbs";
import VendorsCard from "./-vendors-card";
import WarehouseGraph from "./-warehouse-predictions";
import { WarehouseActions } from "./-warehouse-actions";
import ParentKitsTable from "./-parent-components-table";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_warehouse-360/warehouse/$warehouseId/",
)({
  loader: ({ context: { queryClient }, params: { warehouseId } }) =>
    queryClient.ensureQueryData(
      getGetWarehouseQueryOptions(numericId(warehouseId)),
    ),
  component: WarehouseProductDetailsPage,
});

function WarehouseProductDetailsPage() {
  const { warehouseId } = Route.useParams();
  const warehouseIdInt = numericId(warehouseId);

  const { data: warehouse } = useSuspenseQuery(
    suspenseOptions(getGetWarehouseQueryOptions(warehouseIdInt)),
  );

  return (
    <div>
      <title>{`${warehouse?.catalog_product.product_base.name} Warehouse - Legrande Health Portal`}</title>
      <WarehouseCrumbs>
        {warehouse && <WarehouseActions warehouse={warehouse} />}
      </WarehouseCrumbs>
      <div className="flex flex-col gap-4 grid-flow-row">
        {warehouse && (
          <>
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="w-full">
                <WarehouseProductDetails warehouse={warehouse} />
                {warehouse?.is_deleted && (
                  <div className="absolute inset-0 bg-order-cancelled z-50 rounded-lg top-10" />
                )}
              </div>
              <div className="flex flex-col gap-4 w-full">
                {warehouse?.source === "Manufactured" && (
                  <div className="flex flex-col gap-4">
                    <ComponentsCard warehouse={warehouse} />
                  </div>
                )}

                {warehouse?.source === "Purchased" && (
                  <div className="flex flex-col gap-4">
                    <VendorsCard warehouse={warehouse} />
                    {warehouse?.is_deleted && (
                      <div className="absolute inset-0 bg-order-cancelled z-50 rounded-lg top-10" />
                    )}
                  </div>
                )}
              </div>
            </div>

            <ParentKitsTable warehouseId={warehouseIdInt} />

            {/* Only show the batch table if we have a linked warehouse_vendor */}
            <div className="col-span-full">
              {warehouse.warehouse_vendors.length > 0 && (
                <BatchLookupTable warehouse={warehouse} />
              )}
            </div>

            <div className="col-span-full">
              <WarehouseGraph warehouse={warehouse} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
